import { startWithServerTime } from '@saha/time';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.css';
import { antdLocale } from './localization';
import reportWebVitals from './reportWebVitals';

void startWithServerTime(process.env.REACT_APP_API_BASE_URL!, async () => {
  const { default: App } = await import('./App');
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <ConfigProvider locale={antdLocale}>
        <App />
      </ConfigProvider>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
